/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch, useSelector } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { FOREGROUNDCOLOR } from "../../helpers/colors";
import { Button } from "primereact/button";
import {
  Link,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import loading from "../../assets/loading.gif";
import {
  emptyNotices,
  fetchNotices,
  pushNotice,
  searchNotice,
  selectAllNotices,
  updateNotices,
} from "../../features/notice/noticesSlice";
import { Card, IconButton } from "@mui/material";
import { toast } from "react-hot-toast";
import { router } from "../../routes";
import { GetPositionById } from "../../services/PositionService";
import { number, string } from "yup";
import { Any } from "@react-spring/web";
import NoticeCard from "./Card/NoticeCard";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import {
  fetchUserProfile,
  getMyProfile,
} from "../../features/profile/profileSlice";
import { GetMyCompanyAcceleratorsNoticeIds } from "../../services/CompanyService";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Grid, Row, Spin } from "antd";
import NoticeCardV2 from "./Card/NoticeCardV2";
import { GetNoticesOData } from "../../services/NoticeODataService";
import CustomLabel from "../share/customLabel";
const { useBreakpoint } = Grid;
const NoticeView = (info: { tabNumber: number }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  // const noticeList = useSelector(selectAllNotices);
  const noticeStatus = useSelector((state) => (state as any).notices.status);
  const [myAccelerators, setMyAccelerators] = useState<any>([]);
  const [page, setPage] = useState(0);
  const params = useParams();
  const [searchParams] = useSearchParams();

  const myPositions = useSelector(getMyPosition);
  const myProfile = useSelector(getMyProfile);
  const [clientHeight, setClientHeight] = useState(0);
  const [noticeList, setNoticeList] = useState([]);
  const [clientWidth, setClientWidth] = useState(0);

  useEffect(() => {
    if (info.tabNumber === 4) {
      return;
    }
    const newParams = new URLSearchParams(searchParams);

    if (!newParams.has("flag")) {
      LoadNotices();
    }
  }, [searchParams, info.tabNumber]);
  const path = useLocation();
  const [getTab, setTab] = useState(searchParams.get("tab"));

  const LoadNotices = () => {
    console.log("tabLoad", info.tabNumber);

    if (info.tabNumber === 4) {
      return;
    }
    console.log("pr", params);
    console.log("pr2", searchParams);

    const filterConditions: string[] = [];
    searchParams.forEach((value, key) => {
      if (
        !["page", "pageSize", "sortField", "sortOrder", "tab", "flag"].includes(
          key
        )
      ) {
        filterConditions.push(`contains(${key}, '${value}')`);
      }
    });
    const otherQuery = filterConditions.length
      ? `$filter=${filterConditions.join(" and ")}`
      : "";

    GetNoticesOData(
      1000,
      0,
      "$orderby=CreatedDate desc",
      otherQuery,
      info.tabNumber
    ).then((p) => {
      setNoticeList(p.data.value);
      navigate(
        `/notice/${
          params.id === undefined ? p.data.value[0].Id : params.id
        }?${searchParams}`
      );
    });
  };

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);

    if (info.tabNumber === 4) {
      return;
    }
    if (localStorage.getItem("token") === null) {
      navigate("/login");
    }
    LoadNotices();
    setClientHeight(document.documentElement.clientHeight);
    setClientWidth(document.documentElement.clientWidth);
    dispatch(fetchUserPosition());
    dispatch(fetchUserProfile());

    GetMyCompanyAcceleratorsNoticeIds().then((p) => {
      setMyAccelerators(["2926cbb2-c4dc-4135-f286-08dceda5fee7"]);
    });
    const handleResize = () => {
      setClientWidth(document.documentElement.clientWidth);
      setClientHeight(document.documentElement.clientHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //   useEffect(() => {
  //
  //     setPage(0);
  //
  //   }, [params.qry]);
  //

  const handleCopyContent = (input: string) => {
    const contentToCopy = input; // Replace with the content you want to copy

    const textarea = document.createElement("textarea");
    textarea.value = contentToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    // console.log("Content copied to clipboard");
  };

  const copyNotice = (input: any) => {
    //console.log(input);
    handleCopyContent(input);
    toast.success("کپی شد");
  };

  const screens = useBreakpoint();
  const { id } = useParams<{ id: string }>();
  const noticeRefs = useRef<Map<string, HTMLDivElement>>(new Map());

  useEffect(() => {
    if (info.tabNumber === 4) {
      return;
    }
    if (!id) return;
    console.log("noticeRefs", "id", id);

    setTimeout(() => {
      const selectedCard = noticeRefs.current.get(id);
      console.log("noticeRefs", "noticeRefs.current", noticeRefs.current);

      console.log("noticeRefs", "selectedCard1", selectedCard);

      if (selectedCard) {
        console.log("noticeRefs", "selectedCard", selectedCard);
        selectedCard.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }, [id, noticeList]);

  return (
    <>
      {!screens.xs && clientWidth > 1510 ? (
        <>
          <Row>
            <Col
              style={{
                backgroundColor: "transparent",
                height: clientHeight.toString() + "px",

                display: "inline-flex",
              }}
            >
              <div
                className="mt-2"
                style={{
                  textAlign: "center",
                  overflow: "scroll",

                  scrollbarWidth: "thin",
                  direction: "rtl",
                  marginRight: "5px",
                }}
              >
                {myProfile.id !== "" && myProfile.id !== undefined ? (
                  noticeList.length === -19 ? (
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                      }
                    />
                  ) : (
                    <></>
                  )
                ) : (
                  <>
                    <p style={{ color: "red" }}>
                      برای مشاهده آگهی ها لطفا وارد سیستم شوید
                    </p>
                  </>
                )}
                {noticeList.map((noticep: any) => (
                  <section
                    ref={(el: any) => {
                      if (el) {
                        // Ensure the ref is typed for HTMLSectionElement
                        noticeRefs.current.set(noticep.Id, el);
                        // console.log(`Ref set for ${noticep.id}:`, el); // Debug log
                      }
                    }}
                    key={noticep.Id}
                    id={noticep.Id} // Optionally, you can also set an id on the section to make it easier to target in the URL
                  >
                    <NoticeCardV2
                      ref={(el: any) => {
                        if (el) {
                          noticeRefs.current.set(noticep.Id, el); // Set ref for each card
                          console.log("Ref", noticep.Id);

                          console.log(`  set for ${noticep.Id}:`, el); // Debug log
                        }
                      }}
                      key={noticep.Id}
                      notice={noticep}
                      acc={myAccelerators}
                    />
                  </section>
                ))}
              </div>
            </Col>
            <Col
              style={{
                width: (clientWidth - 660).toString() + "px",
                height: clientHeight.toString() + "px",
                backgroundColor: "transparent",
                overflow: "scroll",
                scrollbarWidth: "none",
                display: "inline-flex",
              }}
            >
              {/* {clientWidth} */}
              {noticeList.length > 0 ? (
                <>
                  <Outlet />
                </>
              ) : (
                <>
                  <CustomLabel
                    style={{
                      margin: "auto",
                      position: "absolute",
                      top: 100,
                      right: clientWidth / 2.7,
                    }}
                  >
                    داده ای برای نمایش وجود ندارد
                  </CustomLabel>
                </>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col
              style={{
                width: "100%",
                backgroundColor: "transparent",
                height: clientHeight.toString() + "px",
                overflow: "scroll",
                scrollbarWidth: "none",
              }}
            >
              <div
                className="mt-2 container-fluid "
                style={{ textAlign: "center" }}
              >
                {myProfile.id !== "" && myProfile.id !== undefined ? (
                  noticeList.length === -19 ? (
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                      }
                    />
                  ) : (
                    <></>
                  )
                ) : (
                  <>
                    {" "}
                    <p style={{ color: "red" }}>
                      {" "}
                      برای مشاهده آگهی ها لطفا وارد سیستم شوید{" "}
                    </p>{" "}
                  </>
                )}
                {noticeList.map((noticep: any) => (
                  <NoticeCardV2
                    key={noticep.id}
                    notice={noticep}
                    acc={myAccelerators}
                  />
                ))}
              </div>
            </Col>
            <Col
              style={{
                width: "70%",
                height: clientHeight.toString() + "px",
                overflow: "scroll",
                scrollbarWidth: "none",
                margin: "auto",
              }}
            >
              <Outlet />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
export default NoticeView;
